var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"button",staticClass:"btn",class:_vm.buttonClass,attrs:{"href":_vm.linkHref,"data-icon":_vm.icon},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }